/** @jsx jsx */
import { Box, Flex, Paragraph, Radio } from "@eworkit/iris";
import { useBreakpointIndex } from "@theme-ui/match-media";
import { FC, useCallback } from "react";
import { jsx } from "theme-ui";

import { Collapsible } from "@/eworkitComponents";
import { JobApplicationPayExpressBestChoiceLabel } from "@/views/job-applications/apply/_details/_compontents/JobApplicationPayExpressBestChoiceLabel";

interface JobApplicationPayExpressRadioBoxProps {
  title: string;
  checked?: boolean;
  recommended?: boolean;
  feeAmount?: string;
  showFeeAmount?: boolean;
  term: number;
  onCheckAction: (term: number) => void;
  error?: boolean;
}

export const JobApplicationPayExpressRadioBox: FC<JobApplicationPayExpressRadioBoxProps> = ({
  checked = false,
  title,
  children,
  onCheckAction,
  recommended,
  term,
  error,
}) => {
  const breakpoint = useBreakpointIndex();

  const handleOptionCheck = useCallback(() => {
    onCheckAction(term);
  }, [onCheckAction, term]);

  return (
    <Box
      borderRadius="md"
      border="primary"
      p="md"
      onClick={handleOptionCheck}
      sx={{
        cursor: "pointer",
        backgroundColor: checked ? "vg50" : "",
        borderColor: error ? "r600" : checked ? "vg500" : "",
        transition: "all 0.3s ease-in-out",
      }}>
      <Flex flexDirection="column">
        <Flex justifyContent="space-between" alignItems="center">
          <Flex alignItems="center" gap="xs">
            <Radio checked={checked} disabled={!checked} />
            <Paragraph bold={checked}>{title}</Paragraph>
            {recommended && breakpoint >= 2 && <JobApplicationPayExpressBestChoiceLabel />}
          </Flex>
        </Flex>
        {recommended && breakpoint < 2 && (
          <Flex pl="lg" flexGrow={0}>
            <JobApplicationPayExpressBestChoiceLabel />
          </Flex>
        )}
        <Collapsible duration={0.3} collapsed={!checked}>
          <Flex flexDirection="column" gap="sm" pl="lg" pt="xs">
            {children}
          </Flex>
        </Collapsible>
      </Flex>
    </Box>
  );
};
